/* globals CONFIG */
// This is injected by webpack during build time
export default CONFIG;
